<template>
    <div id="app">
        <router-view v-if="isReloadAlive" :key="$route.query.t"></router-view>
    </div>
</template>

<script>
import {setCookie, getCookie, delCookie} from './utils/cookieUtil.js'
export default {
    name: 'App',
    provide(){
        return {
            reload:this.reload
        }
    },
    data(){
        return {
            isReloadAlive:true
        }
    },
    mounted:function(){
        this.init()
    },
    methods:{
        // 判断当前用户是否冠闵用户 如果是定时触发播放音乐
        init(){
            if(getCookie(global.cookieName)!= undefined && getCookie(global.cookieName)!= ''&&getCookie(global.companyId)==1){
                window.setInterval(() => {
                    setTimeout(() => {
                        this.$api.ticket.isNeedReminder({
                            "duration":12
                        })
                        .then(res=>{
                            if(res.data==true){
                                this.music = new Audio("./static/tip.mp3");
                                let playPromise = this.music.play();

                                if (playPromise !== undefined) {
                                    playPromise.then(() => {
                                        this.music.play();
                                    }).catch(()=> {
                                })}

                                this.$Notice.open({
                                    title: this.$t('common.notice'),
                                    desc:this.$t('common.noticeContent'),
                                    duration: 10
                                });
                            }
                        })
                    }, 0)
                }, 10 * 60 * 1000)
            }
        },
        reload(){
            this.isReloadAlive=false;
            this.$nextTick(function(){
                this.isReloadAlive=true;
            })
        }
    }
}
</script>

<style>
    body {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }
    li, ul, p, div, body, html, table {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
    }
    html, body {
        height: 100%;
        overflow: hidden;
    }
    li {
        list-style: none;
    }
    #app {
        height: 100%;
    }
    label{
        margin: 0;
    }
</style>



// WEBPACK FOOTER //
// src/App.vue